import { render, staticRenderFns } from "./compBoleto.vue?vue&type=template&id=47f2a0d0&"
import script from "./compBoleto.vue?vue&type=script&lang=js&"
export * from "./compBoleto.vue?vue&type=script&lang=js&"
import style0 from "./compBoleto.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports